export function animate() {

    const init = function () {

        var elements = [].slice.call(document.querySelectorAll('[data-animate]'));

        if (!elements || elements.length === 0)
            return;

        if (!("IntersectionObserver" in window))
            return;

        var lazyAnimationObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('animate-pending');
                    entry.target.classList.add('animate');
                    entry.target.classList.add(entry.target.getAttribute('data-animate'));

                    lazyAnimationObserver.unobserve(entry.target);
                }
            });
        });

        elements.forEach(function (element) {
            if (element.getAttribute('data-animate').length > 0) {
                lazyAnimationObserver.observe(element);
            }            
        });
    };

    init();
}